import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill="#193446" d="M4.666 12.339v3.894a4.1 4.1 0 0 0 1.142 2.847 3.84 3.84 0 0 0 2.758 1.179 3.84 3.84 0 0 0 2.758-1.18 4.1 4.1 0 0 0 1.143-2.846V6.738c0-.633.243-1.24.677-1.688a2.28 2.28 0 0 1 1.634-.699c.614 0 1.202.252 1.635.7s.677 1.054.677 1.687v3.894l-1.576-1.63-1.124 1.158 3.495 3.611 3.494-3.61-1.124-1.159-1.576 1.63V6.738a4.1 4.1 0 0 0-1.142-2.847 3.84 3.84 0 0 0-2.758-1.18 3.84 3.84 0 0 0-2.758 1.18 4.1 4.1 0 0 0-1.143 2.847v9.501c0 .633-.243 1.24-.677 1.688a2.28 2.28 0 0 1-1.635.699 2.28 2.28 0 0 1-1.635-.7 2.43 2.43 0 0 1-.677-1.687v-3.894l1.577 1.63 1.123-1.159L5.46 9.197l-3.492 3.611 1.124 1.158z"/>' }
  })
);